import { apiUrl } from "../Utility";
import fb from "../fb.js";
import _ from "lodash";
export const GET_USER_START = "GET_USER_START";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const GET_USER_FAILURE = "GET_USER_FAILURE";
export const SET_USER = "SET_USER";
export const SIGN_OUT = "SIGN_OUT";
export const PASS_RESET = "PASS_REST";
export const GET_LIBRARY_FINISH = "GET_LIBRARY_FINISH";
export const GET_LIBRARY_START = "GET_LIBRARY_START";
export const UPDATE_HERO_IMG = "UPDATE_HERO_IMG";
export const CHOOSE_SHOW = "CHOOSE_SHOW";
export const CHOOSE_HERO = "CHOOSE_HERO";
export const UPDATE_SETTINGS = "UPDATE_SETTINGS";
export const GET_PLAYLISTS_START = "GET_PLAYLISTS_START";
export const GET_PLAYLISTS_FINISH = "GET_PLAYLISTS_FINISH";
export const GET_PLAYLIST_START = "GET_PLAYLIST_START";
export const GET_PLAYLIST_FINISH = "GET_PLAYLIST_FINISH";
export const TEMP_PLAYLIST = "TEMP_PLAYLIST";
export const ADD_SUCCESS = "ADD_SUCCESS";
export const ADD_START = "ADD_START";
export const ADD_FAIL = "ADD_FAIL";
export const CREATE_QUEUE = "CREATE_QUEUE";
export const CLEAR_QUEUE = 'CLEAR_QUEUE'
export const ADD_TO_QUEUE = 'ADD_TO_QUEUE'
export const INCREMENT_QUEUE_INDEX = 'INCREMENT_QUEUE_INDEX'
export const RESTART_QUEUE = 'RESTART_QUEUE'

export const ChooseHero = content => {
  return (dispatch, getState) => {
    dispatch({ type: CHOOSE_HERO, content });
  };
};

export const ChooseShow = (content, rowNum, history) => {
  return (dispatch, getState) => {
    // console.log(rowNum)
    dispatch(CreateQueue(content, rowNum, history));
    // dispatch({ type: CHOOSE_SHOW, content });
  };
};

export const CreateQueue = (content, rowNum, history) => {  
  return (dispatch, getState) => {
    dispatch({type: CLEAR_QUEUE})
    let state = getState();
    let index = content.index;
    state = JSON.parse(JSON.stringify(state.mainState));
    let library = state.library.view;
    if (content.type === "playlist") {
      if (state.autoPlay) {                
        let obj = {
          index: content.index,
          library: library[rowNum].contentList
        };
        obj.library[obj.index].progress = content.progress        
        dispatch(addToQueue(obj))
        history.push('/Home/Show/0')
        return;
      } else {
        let playlist = []
        for (let i = content.index; i < library[rowNum].contentList.length; i++) {
          if (i >= content.index + 3) break;
          playlist.push(library[rowNum].contentList[i])
        }
        let obj = {
          index: 0,
          library: playlist
        };
        obj.library[obj.index].progress = content.progress
        dispatch(addToQueue(obj))
        history.push('/Home/Show/0')
        return;
      }
    }
    library = _.chain(library)
      .map(o => {
        if (o.type === 'category') {
          return o;
        } else {
          rowNum = rowNum - 1
        }
      })
      .compact()
      .thru(value => {
        for (let i = 0; i < value.length; i++) {          
          if (i === rowNum) {
            i = value.length;            
          } else {            
            index += value[i].contentList.length;
          }
        }
        return value;
      })
      .map(o => {
        return o.contentList;
      })
      .flatten()
      .value();
    if (state.autoPlay) {
      let obj = {
        index: index,
        library: library
      };      
      obj.library[obj.index].progress = content.progress
      dispatch(addToQueue(obj))
      history.push('/Home/Show/0')
    } else {
      let shows = [];
      if (index + 3 >= library.length) {
        library = _.concat(library, library)
      }
      for (let i = index; i < index + 3; i++) {
        shows.push(library[i]);
      }
      let obj = {
        index: 0,
        library: shows
      };      
      obj.library[obj.index].progress = content.progress
      dispatch(addToQueue(obj))
      history.push('/Home/Show/0')
    }
  };
};

export const addToQueue = obj => {
  return (dispatch, getState) => {    
    let currentState = JSON.parse(JSON.stringify(getState()))
    let queue = currentState.mainState.queue
    if (queue.content.length === 0) {
      dispatch({type: ADD_TO_QUEUE, obj})
    } else {
      let playlist = _.concat(queue.content, obj.library)
      obj.index = null
      dispatch({type: ADD_TO_QUEUE, obj})      
    }
  };
};

export const playNextShowInQueue = (history, showCount) => {
  return (dispatch, getState) => {
    let state = JSON.parse(JSON.stringify(getState()))
    let queue = state.mainState.queue
    if (queue.index + 1 >= queue.content.length) {
      if(state.mainState.autoPlay) {
        dispatch({type: RESTART_QUEUE})
        let playCount = parseFloat(showCount) + 1
        history.push(`/Home/Show/${playCount}`)
        return
      }
      history.push('/')
    } else {
      let playCount = parseFloat(showCount) + 1
      dispatch({type: INCREMENT_QUEUE_INDEX})
      history.push(`/Home/Show/${playCount}`)
    }
  }
}

export const getLibrary = token => {
  return function(dispatch, getState) {
    dispatch({ type: GET_LIBRARY_START });
    if (token === undefined) {
      fetch(`https://${apiUrl}/api/v1/roku_view`, { method: "GET" }).then(
        res => {
          res.json().then(library => {
            dispatch({ type: GET_LIBRARY_FINISH, library });
          });
        }
      );
      return;
    }
    fetch(`https://${apiUrl}/api/v1/roku_view?token=${token}`, {
      method: "GET"
    }).then(res => {
      res.json().then(library => {
        // console.log(library.view)
        for (let i = 0; i < library.view.length; i++) {
          // console.log(library.view[i])
          for (let j = 0; j < library.view[i].contentList.length; j++) {
            library.view[i].contentList[j].section = library.view[i].title;
            library.view[i].contentList[j].type = library.view[i].type;
          }
        }
        dispatch({ type: GET_LIBRARY_FINISH, library });
      });
    });
  };
};

export const getPlaylists = token => {
  return (dispatch, getState) => {
    dispatch({ type: GET_PLAYLISTS_START });
    fetch(`https://${apiUrl}/api/v1/user/categories?token=${token}`, {
      method: "GET"
    })
      .then(res => {
        res.json().then(res => {
          if (res.status === "success") {
            let playlists = res.user_categories;
            dispatch({ type: GET_PLAYLISTS_FINISH, playlists });
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };
};

export const addPlaylist = (token, title) => {
  return (dispatch, getState) => {
    const currentState = getState();
    let stateClone = JSON.parse(JSON.stringify(currentState));
    let playlists = stateClone.mainState.playlists;
    console.log(playlists);
    for (let i = 0; i < playlists.length; i++) {
      playlists[i].order = i;
    }
    let nextIndex = playlists.length;
    playlists.push({ title: title, order: nextIndex, id: null });
    console.log(playlists);
    fetch(`https://${apiUrl}/api/v1/user/categories/updateAll?token=${token}`, {
      method: "POST",
      body: JSON.stringify({ user_categories: playlists }),
      headers: new Headers({
        "Content-Type": "application/json"
      })
    })
      .then(res => {
        res.json().then(res => {
          if (res.status === "success") {
            console.log(res);
            dispatch(getPlaylists(token));
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };
};

export const deletePlaylist = (title, token) => {
  return (dispatch, getState) => {
    const currentState = getState();
    let stateClone = JSON.parse(JSON.stringify(currentState));
    let playlists = stateClone.mainState.playlists;
    console.log(playlists);
    _.remove(playlists, o => {
      return o.title === title;
    });
    console.log(playlists);
    for (let i = 0; i < playlists.length; i++) {
      playlists[i].order = i;
    }
    console.log(playlists);
    fetch(`https://${apiUrl}/api/v1/user/categories/updateAll?token=${token}`, {
      method: "POST",
      body: JSON.stringify({ user_categories: playlists }),
      headers: new Headers({
        "Content-Type": "application/json"
      })
    })
      .then(res => {
        res.json().then(res => {
          if (res.status === "success") {
            console.log(res);
            dispatch(getPlaylists(token));
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };
};

export const getPlaylistContents = (token, id) => {
  return (dispatch, getState) => {
    dispatch({ type: GET_PLAYLIST_START });
    fetch(
      `https://${apiUrl}/api/v1/user/categories/${id}/videos?token=${token}`,
      { method: "GET" }
    )
      .then(res => {
        res.json().then(res => {
          if (res.status === "success") {
            dispatch({ type: GET_PLAYLIST_FINISH, res });
            dispatch({ type: TEMP_PLAYLIST, res });
          }
        });
      })
      .catch(e => {
        console.log(e);
      });
  };
};

export const addShowToPlaylist = (id, token) => {
  return (dispatch, getState) => {
    dispatch({ type: ADD_START });
    let currentState = getState();
    currentState = JSON.parse(JSON.stringify(currentState));
    let video_id = currentState.mainState.idToAdd;
    console.log(video_id);
    fetch(
      `https://${apiUrl}/api/v1/user/categories/${id}/videos/create?token=${token}&video_id=${video_id}`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json"
        })
      }
    ).then(res => {
      res
        .json()
        .then(res => {
          if (res.status === "success") {
            dispatch({ type: ADD_SUCCESS });
            dispatch(getLibrary(token));
            setTimeout(() => {
              dispatch({ type: "TOGGLE_ADD_TO_PLAYLIST" });
              dispatch({ type: "RESET_ADD_STATE" });
            }, 1000);
          }
        })
        .catch(e => {
          dispatch({ type: ADD_FAIL });
          setTimeout(() => {
            dispatch({ type: "RESET_ADD_STATE" });
          }, 1000);
          console.log(e);
        });
    });
  };
};

export const toggleAutoPlay = isAutoPlay => {
  return dispatch => {
    dispatch({ type: UPDATE_SETTINGS, isAutoPlay });
  };
};

export const updateHeroImg = url => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_HERO_IMG, url });
  };
};

/*****************************************************************/
/*                                                               */
/*                                                               */
/*                                                               */
/*                Account Management Functions                   */
/*                                                               */
/*                                                               */
/*                                                               */
/*****************************************************************/

export const signIn = (token, history) => {
  return function (dispatch, getState) {
    dispatch(getUser(token, history))
    history.push('/')
  }
}

export const signOut = () => {
  return function (dispatch) {
    dispatch({ type: SIGN_OUT })
  }
}

export const signup = (payload, history) => {
  return function (dispatch) {
    let revenue = null

    switch (payload.payments.plan) {
      case 'hdmonth':
        revenue = '2.99'
        break;
      case '4kmonth':
        revenue = '5.99'
        break;
      case 'hdyear':
        revenue = '29.99'
        break;
      case '4kyear':
        revenue = '59.99'
        break;
      default:
        break;
    }
    dispatch({ type: GET_USER_START })
    history.push('/')
    console.log(payload.payments)
    const req = new Request(`https://${apiUrl}/api/v1/user/register`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })

    fetch(req)
      .then(response => {
        response.json().then(data => {
          // console.log(data)
          if (data.status !== 'failure') { 
          //   ReactGA.plugin.execute('ecommerce', 'addTransaction', {
          //     id: 'UA-113242156-3',
          //     revenue: revenue
          //   });
          //   ReactGA.ga('event', 'conversion', {
          //     'send_to': '809351643',
          //     'value': revenue,
          //     'currency': 'USD',
          //     'event_callback': null
          // })
            dispatch(signIn(data.auth_token, history)) 
          }
        })
      })
  }
}

// export const signIn = (token, history, email) => {
//   return function(dispatch, getState) {
//     dispatch(getUser(token, history, email));
//     history.push("/");
//   };
// };

// export const signOut = () => {
//   return function(dispatch) {
//     dispatch({ type: SIGN_OUT });
//   };
// };

// export const signup = (payload, history) => {
//   return function(dispatch) {
//     dispatch({ type: GET_USER_START });
//     history.push("/");

//     const req = new Request(`https://${apiUrl}/api/v1/user/register`, {
//       method: "POST",
//       body: JSON.stringify(payload),
//       headers: new Headers({
//         "Content-Type": "application/json"
//       })
//     });

//     fetch(req).then(response => {
//       response.json().then(data => {
//         // console.log(data)
//         if (data.status !== "failure") {
//           dispatch(signIn(data.auth_token, history));
//         }
//       });
//     });
//   };
// };


export const getUser = (token, history) => {
  return function(dispatch, getState) {
    dispatch({ type: GET_USER_START });

    // Get the user
    fetch(`https://${apiUrl}/api/v1/user/info?token=${token}`, {
      method: "GET"
    })
      .then(response => {
        response
          .json()
          .then(user => {
            user.token = token;
            dispatch({ type: GET_USER_SUCCESS, user: user });
            if (history.location.pathname === "/termsofuse") {
              return;
            }
            if (history.location.pathname === "/privacy") {
              return;
            }
            history.push("/");
          })
          .catch(e => {
            console.log(e);
            dispatch({ type: GET_USER_FAILURE });
          });
      })
      .catch(e => {
        console.log(e);
        dispatch({ type: GET_USER_FAILURE });
      });
  };
};

export const updateUser = (token, obj, history) => {
  return function (dispatch) {
    dispatch({ type: GET_USER_START })

    const req = new Request(`https://${apiUrl}/api/v1/user/update?token=${token}`, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })

    fetch(req)
      .then(response => {
        console.log(response)
        response.json().then(data => {
          console.log(data)
          dispatch(getUser(token, history))
        })
      })
  }
}

export const unsubscribeUser = (token, history) => {
  return function (dispatch) {
    dispatch({ type: GET_USER_START })
    
    const req = new Request(`https://${apiUrl}/api/v1/user/unsubscribe?token=${token}`, {
      method: 'POST',
      body: JSON.stringify({ platform: 'stripe' }),
      headers: new Headers({
        'Content-Type': 'application/json'
      })
    })

    fetch(req)
      .then(response => {
        response.json().then(data => {
          console.log(data)
          dispatch(getUser(token, history))
        })
      })
  }
}





// WEBPACK FOOTER //
// ./src/js/Actions/Actions.js